<template>
  <v-main>
    <Annoucements />
  </v-main>
</template>

<script>
import Annoucements from '@/components/announcements'
export default {
  name: 'announcements-view',
  components: { Annoucements }
}
</script>

<style scoped>
</style>
